import 'bootstrap/dist/css/bootstrap.min.css';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// date-fns
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// or for dayjs
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// // or for luxon
// import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
// // or for moment
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

// import "./index.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import config from './config';
import { initRum } from './rum';
import { RumPageViewTracker } from './rum-page-view-tracker';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.cognito.USER_POOL_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID,
    },
  },
  API: {
    REST: {
      applications: {
        service: 'applications',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      dealers: {
        service: 'dealers',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      payments: {
        service: 'payments',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      documents: {
        service: 'documents',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      news: {
        service: 'news',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      'admin-docs': {
        service: 'admin-docs',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      files: {
        service: 'files',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      users: {
        service: 'users',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      'dealer-documents': {
        service: 'dealer-documents',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      dealerProspects: {
        service: 'dealer-prospects',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      quotes: {
        service: 'quotes',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      contracting: {
        service: 'contracting',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
    },
  },
});

initRum();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Router>
        <RumPageViewTracker />
        <App />
      </Router>
    </LocalizationProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
